import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { DiseaseFilterSettingsModel } from "../models/";

class DiseaseService {

	lang: string = '';

	constructor(lang?) {
		this.lang = lang;
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Pragma: 'no-cache',
			"langId": HelperFunctions.getLangId(lang)
		}
	}

	getAllDiseases(from: number, numberOfRows: number, settings: DiseaseFilterSettingsModel, lang: string) {
		return axios({
			url: `disease/getAll/${from}/${numberOfRows}`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				"langId": HelperFunctions.getLangId(lang)
			},
			data: JSON.stringify(settings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

}

export default DiseaseService;
